import { Controller } from 'stimulus'
import Google from 'mixins/google'

export default class extends Google(Controller) {

  static targets = ['map', 'markerTemplate']

  connect() {
    this.googleConnect()
  }

  disconnect() {
    if (this.map) google.maps.event.clearInstanceListeners(this.map)
  }

  googleConnected() {
    if (!this.element.matches('.dn')) this.initMap()
  }

  initMap() {
    if (this.map) return
    this.infowindow = new google.maps.InfoWindow()
    this.markerBounds = new google.maps.LatLngBounds()
    let pins = JSON.parse(this.element.dataset.pins)
    this.map = new google.maps.Map(this.element, {
      center: pins[0],
      zoom: 14
    })

    for(let pin of pins) {
      if (pin['lat'] == 0) continue
      this.markerBounds.extend(pin)
      let marker = new google.maps.Marker({
        position: pin,
        map: this.map
      })
      let map = this.map
      marker.addListener("click", () => {
        this.infowindow.setContent(decodeURI(pin.content))
        this.infowindow.open({
          anchor: marker,
          map,
          shouldFocus: false,
        })
      })
    }

    this.map.fitBounds(this.markerBounds)
  }
}
